import React from "react";
import { connect } from "react-redux";
import KpiIndicator from "../components/KpiIndicator";
import { getCurrentCompiledData, getCurrentStatsObj, getKpiSelected } from "../selectors";

const mapStateToProps = (state) => {
	return {
		kpi: getKpiSelected(state),
		data: getCurrentCompiledData(state),
		statsObj: getCurrentStatsObj(state),
	};
};

export default connect(
	mapStateToProps,
	{},
)(KpiIndicator);



// WEBPACK FOOTER //
// src/modules/stats/containers/KpiIndicatorContainer.js